module.exports = __webpack_public_path__ + "static/media/outreach-client.0b22375f.svg";